module.exports = __webpack_public_path__ + "img/ill1.973865a7.svg";